import { DEFAULT_PROFILE_FIELDS, type ProfileFieldKey, type ProfileFieldMap } from 'js/profile-field-map';

export { DEFAULT_PROFILE_FIELDS, type ProfileFieldKey, type ProfileFieldMap };

let cachedProfileFields: ProfileFieldMap | undefined;

/**
 * Returns the active profile-field map for this site, layering any
 * `CONFIG.profileFields` overrides on top of the canonical defaults.
 */
export function getProfileFields(): ProfileFieldMap {
  if (cachedProfileFields) {
    return cachedProfileFields;
  }
  const overrides = Object.fromEntries(
    Object.entries(CONFIG.profileFields ?? {}).filter(
      (entry): entry is [ProfileFieldKey, string] => typeof entry[1] === 'string' && entry[1].length > 0
    )
  ) as Partial<ProfileFieldMap>;
  cachedProfileFields = { ...DEFAULT_PROFILE_FIELDS, ...overrides };
  return cachedProfileFields;
}
